import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=cc3af1ba&lang=pug&"
import script from "./Accounting.vue?vue&type=script&lang=ts&"
export * from "./Accounting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports